/**
 * Dropoff / garage alert time thresholds.
 * Single source of truth for when dropoff-related alerts and navigation mode apply.
 */
export const DROPOFF = {
  /** NoScheduledDrive: show GoToGarage when this many minutes (or less) until shift end */
  GO_TO_GARAGE_IN_NO_SCHEDULED_DRIVE_MAX_MINUTES: 30,

  /** Automatic garage: show TimeToDropoff countdown only when this many minutes (or less) until dropoff start */
  TIME_TO_DROPOFF_ALERT_MAX_MINUTES: 50,

  /** TimeToDropoffAlert: use detailed message ("Shift ends HH:MM...") when more than this many minutes to go */
  TIME_TO_DROPOFF_DETAILED_MESSAGE_MINUTES: 5,

  /** When to start driving to garage = dropoff time minus this (seconds), if no drive duration from API */
  BUFFER_SECONDS: 20 * 60,

  /** Directions-to-dropoff query: enable when dropoff time is within this many minutes */
  QUERY_START_MINUTES_BEFORE: 120,

  /** Directions-to-dropoff query stale time (minutes) */
  QUERY_STALE_MINUTES: 3,
} as const

/** Seconds threshold for showing GoToGarage in NoScheduledDrive (derived from DROPOFF) */
export const GO_TO_GARAGE_IN_NO_SCHEDULED_DRIVE_THRESHOLD_SECONDS =
  DROPOFF.GO_TO_GARAGE_IN_NO_SCHEDULED_DRIVE_MAX_MINUTES * 60
